import { reactive } from "vue";
import { getStorage, setStorage } from "@/utils/storage";

function throttle(fn, delay) {
  let lastTime = 0;
  return function (...args) {
    const nowTime = new Date().getTime();
    if (nowTime - lastTime >= delay) {
      fn.apply(this, args);
      lastTime = nowTime;
    }
  };
}

function getWindowsInfo() {
  const windowWidth = window.innerWidth; // 窗口宽度
  const windowHeight = window.innerHeight; // 窗口高度
  const windowTop = window.scrollY; // 窗口顶部位置
  const windowBottom = window.scrollY + window.innerHeight; // 窗口底部位置

  return {
    windowWidth,
    windowHeight,
    windowTop,
    windowBottom,
  };
}

function getEnvironment() {
  let result = "";
  // #ifdef H5
  let ng = navigator.userAgent;
  let detectDeviceType =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|Mobile|IEMobile|Opera Mini/i.test(
      ng
    )
      ? false
      : true;
  var ua = window ? window.navigator.userAgent.toLowerCase() : "";
  if (
    ua.match(/MicroMessenger/i) == "micromessenger" &&
    ua.match(/wxwork/i) != "wxwork"
  ) {
    // 是微信客户端
    result = detectDeviceType ? "pc-wechat" : "phone-wechat";
  } else {
    if (
      ng.indexOf("csdgpt") != -1 ||
      window.win_message !== undefined ||
      getStorage("desktop") === "isDesktop"
    ) {
      result = "desktop-app";
    } else {
      result = detectDeviceType ? "pc-web" : "phone-web";
    }
  }
  // #endif
  // #ifdef APP-PLUS
  result = "app";
  // #endif
  return result;
}

function useDeviceEnv() {
  const deviceInfo = reactive({
    isMobile: false,
    isPc: false,
    isWeChat: false,
    isDesktop: false,
    is360Client: false,
    isWeb: false,
    isApp: false,
    isIOS: false,
    isAndroid: false,
    isShowLeftTabBar: false,
    isAppWebView: false,
    windowWidth: null,
    windowHeight: null,
    windowTop: null,
    windowBottom: null,
  });
  function initGetEnvironment() {
    const deviceType = getEnvironment();
    deviceInfo.isPc = deviceType.includes("pc");
    deviceInfo.isMobile = deviceType.includes("phone");
    deviceInfo.isWeChat = deviceType.includes("wechat");
    deviceInfo.isWeb = deviceType.includes("web");
    deviceInfo.isDesktop = deviceType.includes("desktop");
    deviceInfo.is360Client = deviceType.includes("is360client");
    // 360联运的也是客户端
    if (deviceInfo.is360Client) {
      deviceInfo.isDesktop = true;
    }
  }
  initGetEnvironment();
  let checkTime = 5;
  let intervalTimer = setInterval(() => {
    checkTime--;
    initGetEnvironment();
    if (checkTime <= 0) {
      clearInterval(intervalTimer);
    }
  }, 200);
  // #ifdef H5
  const isIOS = /(iPhone|iPad|iPod)/i.test(navigator.userAgent);
  deviceInfo.isIOS = isIOS;
  const isAndroid = /(Android)/i.test(navigator.userAgent);
  deviceInfo.isAndroid = isAndroid;
  // #endif
  deviceInfo.isShowLeftTabBar = deviceInfo.isPc;
  if (deviceInfo.isDesktop) {
    window.getSource = getSource;
    window.getDevice = getDevice;
  }
  // #ifdef APP-PLUS
  deviceInfo.isApp = true;
  // #endif

  function getSource(e) {
    setStorage("source", e.param.data);
  }
  function getDevice(e) {
    if (!getStorage("deviceCode")) setStorage("deviceCode", e.param.data);
    // config.reportEvent();
  }
  function getWindowSize(res) {
    deviceInfo.windowWidth = res?.size?.windowWidth;
    deviceInfo.windowHeight = res?.size?.windowHeight;
  }
  const throttleReszie = throttle(getWindowSize, 200);
  const mixins = {
    created() {
      //
    },
    mounted() {
      let i = 8;
      let timer = setInterval(() => {
        if (i === 0) {
          clearInterval(timer);
          return;
        }
        i--;
        const { windowBottom, windowHeight, windowTop, windowWidth } =
          getWindowsInfo();
        const windowInfo = {
          windowBottom,
          windowHeight,
          windowTop,
          windowWidth,
        };
        Object.assign(deviceInfo, windowInfo);
      }, 200);
    },
    destroyed() {
      //
    },
  };
  return {
    deviceInfo,
    mixins,
  };
}

export default useDeviceEnv;
